// @givmo/board — the factor a director's own act answered with, in ONE set of words (CBG-UX3).
//
// Every Board surface that says how a director re-proved an act — the consent log, the record's
// history, the minutes signatures, a disclosure's line — takes the factor's words from here, so one
// act never reads "confirmed with an emailed code" on one page and "confirmed with a code sent by
// email" on the next. They are the consent log's words, and the backend's readable minute book says
// the same (`board_written_consents.signature_act_words`). "authenticator app" is kept together with
// a non-breaking space, so a phone never splits it across two lines (CBG-UX4).
//
// What was recorded and nothing more: the methods are not equivalent (an authenticator is stronger
// than an emailed code, which re-proves the same mailbox the access link arrived on), so the method
// is named rather than flattened into "confirmed". An unknown method names no factor.

/**
 * "a passkey" / "an authenticator app" / "a code sent by email", or null for no factor or an unknown
 * one. `passkey_uv` is a director signing with their account's passkey (CBG-SEC2; the backend's
 * readable minute book says "confirmed with a passkey", approved in copy round 2, D-CBG-18);
 * `email_code` stays for acts recorded before directors signed in with accounts.
 */
export function factorNoun(method: string | null | undefined): string | null {
  switch ((method ?? '').trim().toLowerCase()) {
    case 'passkey_uv':
      return 'a passkey';
    case 'totp':
      return 'an authenticator app';
    case 'email_code':
      return 'a code sent by email';
    default:
      return null;
  }
}

/** "confirmed with an authenticator app" / "confirmed with a code sent by email", or null. */
export function factorLabel(method: string | null | undefined): string | null {
  const noun = factorNoun(method);
  return noun === null ? null : `confirmed with ${noun}`;
}
